import { fak } from '@awesome.me/kit-efa592c48d/icons';

import { IconLibrary } from '@silae/composables';

export const kitLibrary: IconLibrary = { ...fak };
